// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"17eb1f8c","703":"aafdfe97"}[chunkId] + ".chunk.js";
};